var React = require('react');

function AngleRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.15506 16.8158C6.96711 16.5924 6.95002 16.243 7.1038 15.9967L7.15506 15.9262L11.7216 10.5L7.15506 5.07382C6.96711 4.8505 6.95002 4.50105 7.1038 4.25479L7.15506 4.18424C7.34301 3.96092 7.63713 3.94062 7.84438 4.12333L7.90376 4.18424L12.8449 10.0552C13.0329 10.2785 13.05 10.628 12.8962 10.8742L12.8449 10.9448L7.90376 16.8158C7.69701 17.0614 7.36181 17.0614 7.15506 16.8158Z","fill":"white"}));
}

AngleRight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AngleRight;

AngleRight.default = AngleRight;
